import React from "react";
import { Wordmark } from "@/components/Wordmark";
import { NAV_LINKS } from "@/lib/site";

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="border-t border-border bg-surface">
            <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
                <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-10">
                    <div className="max-w-sm">
                        <Wordmark className="text-xl" />
                        <p className="mt-4 text-muted-foreground leading-relaxed">
                            Fractional AI teams for growing businesses.
                        </p>
                    </div>

                    <nav className="flex flex-wrap gap-x-8 gap-y-3">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>
                </div>

                <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-sm text-muted-foreground">
                    <span>Based in Victoria, BC</span>
                    <span>© {year} ReplAIced.work. All rights reserved.</span>
                </div>
            </div>
        </footer>
    );
}
